import { indicatorStatuses } from 'financialStatus/indicatorStatuses';

export const SAVINGS_RATIO = (LOWER_BOUND = 10, UPPER_BOUND = 20) => {
  return {
    [indicatorStatuses.GOOD.level]: `${UPPER_BOUND}% and above`,
    [indicatorStatuses.FAIR.level]: `${LOWER_BOUND}% to less than ${UPPER_BOUND}%`,
    [indicatorStatuses.NEEDS_ATTENTION.level]: `Below ${UPPER_BOUND}%`,
  };
};
